import * as React from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';

import { useTheme } from '../../../../../theme';
import SelectedFlights, { Props } from '../SelectedFlights/SelectedFlights';

import { getSelectedExchangeFlights } from '@entities/exchange';

const ContentWithSelectedFlights: React.FC<Omit<Props, 'selectedFlights'>> = ({ className, children, ...props }) => {
	const { ContentWithSelectedFlights: theme } = useTheme('Widgets').Exchange;

	const selectedFlights = useSelector(getSelectedExchangeFlights);

	return (
		<div className={cn(theme.root, className)}>
			{selectedFlights.length > 0 && (
				<SelectedFlights className={theme.selectedFlights} selectedFlights={selectedFlights} {...props} />
			)}
			{children}
		</div>
	);
};

export default ContentWithSelectedFlights;
